export default __webpack_public_path__ + "static/media/single-project-page-05-img-16.a0ca6fde.jpg";